// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608050643/js/" + chunkId + "." + {"44":"f473a700","225":"d7b5cd41","481":"f7a08853","486":"2191d08e","770":"bb020bee"}[chunkId] + ".0.9553535945398238.chunk.js";
};